import React, { useEffect, useRef } from 'react';
import Button from '@mui/material/Button';

const ThankYou = ({ competitionType, competition, players, member, newBooking, state, registrationDetails }) => {
    const titleRef = useRef();

    useEffect(() => {
        titleRef.current.scrollIntoView({
            behavior: "smooth",
        });
    }, []);

    const getEmail = () => {
        if (competitionType === 1) {
            return 'golf@stay4golf.se';
        } else {
            return 'info@stay4golf.se';
        }
    }

    const getTitle = () => {
        switch (state) {
            case 1: return 'Tack för din anmälan!';
            case 2: return 'Du är reserv!';
            case 3: return 'Tack för din anmälan!';
            case 5: return 'Tävlingen är stängd';
            case 6: return 'Inga platser kvar';
            default: return '';
        }
    }

    return (
        <div className='thankyou'>
            <h1 ref={titleRef}>{getTitle()}</h1>
            <br />
            {state === 5 && <div>
                <p>Vi är ledsna men denna tävling är nu stängd för fler anmälningar.</p>
            </div>}
            {state === 6 && <div>
                <p>Vi är ledsna men vi kan inte skjutsa fler till denna tävling. Vänligen gör om din bokning, utan skjuts.</p>
            </div>}
            {state !== 5 && state !== 6 && <div>
                <p>
                    Till<br />
                    {competitionType === 1 &&
                        <React.Fragment>
                            <b>{`${competition.track} `} {`${competition.name}`}</b> <br />
                            <b>{`${competition.startingTime.split('T')[0]}`}</b><br />
                            <b>{`Prel. starttid kl. ${competition.startingTime.split('T')[1].substring(0, 5)}`}</b>
                        </React.Fragment>
                    }
                    {competitionType === 2 &&
                        <React.Fragment>
                            <b>{`Sommartouren ${competition.registrationSheetName}`}</b>
                        </React.Fragment>
                    }
                    <br />
                    <br />
                    Anmälan gäller:<br />
                    {players.map(p => {
                        return (
                            <React.Fragment key={p.name}>
                                {competitionType === 1 && <span key={p.name}><b>{p.name}, </b> HCP {p.handicap}</span>}
                                {competitionType === 2 && <span key={p.name}><b>{p.name} {p.dinnerOption === '1' ? ' (Med middag)' : ' (Utan middag)'}</b></span>}
                                <br />
                            </React.Fragment>
                        );
                    })}
                </p>
                <p>Bekräftelse på er anmälan kommer att skickas till:<br /><b>{registrationDetails.email ?? member.email}</b></p>
                <br />
                {state === 2 &&
                    <React.Fragment>
                        <p className='confirm-info reserv-info'>Tyvärr så är denna tävling redan fullbokad så ni har blivit tilldelade en reservplats. Vi på Stay4Golf kommer att ta kontakt med er om det blir lediga platser.</p>
                        <br />
                    </React.Fragment>
                }
                <p className='confirm-info'>Du kommer inom kort att få ett email som bekräftar att vi har tagit emot din anmälan. Om du har några frågor så kan du maila till <a href={`mailto:${getEmail()}`}>{getEmail()}</a>, eller ringa oss på <a href='tel:040294400'>040 – 29 44 00.</a>
                    <br />Vi ses!</p>
                <br />
            </div>}
            <Button variant="contained" color="info" onClick={newBooking} >Ny bokning</Button>
            <br />
            <br />
            <a href="https://stay4golf.se/" target="_blank" rel="noopener noreferrer">https://stay4golf.se/</a>
        </div>
    );
}

export default ThankYou;